<template>
  <FyrAiLogo
    :size="size"
    :hover="isHovered"
    :class="{ 'text-gray-400': !active && isMuted }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  />
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import FyrAiLogo from "@/components/Core/FyrAiLogo.vue";
import { useFeatureGate } from "@/services/feature_gate";

defineProps({
  active: { type: Boolean, default: false },
  size: { type: Number, default: 18 },
});

// Muted when the feature can't be reached from here — locked (not bought) or
// an unresolved entitlement — so the tab reads as "not active yet" rather than
// broken. Not while consent is pending: the panel is usable up to Send and
// takes the consent step there. It stays clickable in all states: the panel
// body explains which one it's in, including offering the retry when the
// flags fetch failed.
const aiChatGate = useFeatureGate("aiChat");
const isMuted = computed(
  () => aiChatGate.isLocked.value || aiChatGate.isError.value,
);
const isHovered = ref(false);
</script>
